export const API_ROUTERS = {
  LOGIN: '/api/login',
  LOGOUT: '/api/logout',
  CREATE_PROFILE: '/api/visitors',
  RESET_PASSWORD_SEND_EMAIL: '/api/visitors/send-reset-email',
  CHECK_ACTIVATION_LINK: '/api/visitors/expired-activationlink',
  RESEND_EMAIL_BY_TOKEN: '/api/visitors/send-activate-email',
  SET_NEW_PASSWORD: '/api/visitors/reset-password',

  // Visitor
  VISITOR: '/api/visitor',
  MEMBERS: '/api/visitor/members',
  MEMBER_TO_USER_CHECK: (id) => `api/visitor/members/${id}/checkJoin`,
  MEMBER_TO_USER_SEND_INVITE: (id) => `api/visitor/members/${id}/join`,
  SCORE: '/api/visitor/snowflake',
  MEMBER_SCORE: (memberId) => `api/visitor/members/${memberId}/snowflake`,
  RESET_SCORE: '/api/visitor/reset-snowflake'
}